<script setup lang="ts">
import { usePayStore } from "./store";

import DesktopView from "./views/DesktopView.vue";
import MobileView from "./views/MobileView.vue";

const payStore = usePayStore();
</script>

<template>
  <DesktopView v-if="payStore.isDesktop" />
  <MobileView v-else />
</template>

<style>
#app {
  width: 100%;
}
html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
body {
  margin: 0;
  min-width: 320px;
  min-height: 100vh;
}
</style>
